import clsx from "clsx";
import { whatDecimalSeparator, compress } from "../../helpers";

export const Decimal = ({
  amount,
  decimals = 8,
  round = 6,
  symbol,
  symbolLeft,
  padSymbol = true,
  className,
  onClick,
  as: Component = "div",
  symbolClassName,
  subscript,
}: {
  amount: bigint;
  decimals?: number;
  round?: number;
  symbol?: string;
  symbolLeft?: boolean;
  padSymbol?: boolean;
  className?: string;
  onClick?: () => void;
  as?: React.ElementType;
  symbolClassName?: string;
  subscript?: boolean;
}) => {
  const dec = amount % BigInt(10 ** decimals);
  const int = BigInt(Math.round(Number(amount - dec) / 10 ** decimals));
  const padded = dec.toString().padStart(decimals, "0");

  let needsSubscript = false;
  if (int <= 0n && dec > 0n && round) {
    const padLength = decimals - dec.toString().length;
    if (padLength >= round) {
      needsSubscript = true;
    }
  }

  const truncated = subscript && needsSubscript ? compress(padded) : padded;
  const trimmed = truncated.substring(0, round);

  return (
    <Component
      className={clsx({
        decimal: true,
        "decimal--label-left": symbolLeft,
        "decimal--no-pad": !padSymbol,
        [`${className}`]: className,
      })}
      onClick={onClick}>
      <span className="decimal__int">
        {(int || "0").toLocaleString()}
        {round > 0 && whatDecimalSeparator()}
      </span>
      {dec.toString().length && round > 0 && (
        <span className="decimal__dec">{trimmed}</span>
      )}
      {symbol && (
        <span
          className={clsx({
            decimal__symbol: true,
            [`${symbolClassName}`]: symbolClassName,
          })}>
          {symbol}
        </span>
      )}
    </Component>
  );
};
